module.exports = ".ck-content .image{clear:both;text-align:center}.ck-content .image>img{display:block;margin:0 auto;max-width:100%}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-loader/lib??ref--1-1!./node_modules/@ckeditor/ckeditor5-image/theme/image.css
// module id = 48
// module chunks = 0